import cn from "classnames"
import { useState } from "react"

import { Flex, Table } from "@/atoms"
import { ButtonLineClamp } from "@/molecules/LineClamp/ButtonLineClamp"

import styles from "./TableCard.module.scss"

import type { TableCardProps } from "."

export const TableCard = <R,>(props: TableCardProps<R>) => {
  const [showAll, setShowMore] = useState(false)

  const {
    noPadding,
    className,
    secondary,
    dataSource = [],
    limit = dataSource.length,
    ...rest
  } = props

  const useShowMore = dataSource.length > limit
  const data = showAll ? dataSource : dataSource.slice(0, limit)

  return (
    <Flex vertical gap={8}>
      <div className={cn(styles.wrapper, secondary && styles.wrapperSecondary)}>
        <Table
          prefixCls="table-card-ks"
          className={cn(
            styles.table,
            { [styles.tableNoPadding]: noPadding },
            { [styles.tableBordered]: rest.bordered },
            className
          )}
          dataSource={data}
          pagination={false}
          {...rest}
        />
      </div>
      {useShowMore && (
        <span>
          <ButtonLineClamp
            collapsed={!showAll}
            onClick={() => setShowMore(!showAll)}
          />
        </span>
      )}
    </Flex>
  )
}
